import { Component } from '@angular/core';
import axios from 'axios';

@Component({
  selector: 'app-map-groupcode',
  templateUrl: './map-groupcode.component.html',
  styleUrls: ['./map-groupcode.component.css']
})
export class MapGroupcodeComponent {


  hurl_s = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?'

  selettimes = [
    /*
    { name: 'ปี พ.ศ.2566-2567', year: '2324' },
    { name: 'ปี พ.ศ.2567-2568', year: '2425' },*/
    { name: 'ปี พ.ศ.2568-2569', year: '2526' },
  ];

  selectzone = [];
  data_map = [];
  list_group = [];
  maps: any[] = [];

  select_year = '';
  select_group = [];
  selectedItem: any = null;
  latlong = { lat: 0, long: 0 }
  showLabels = true; // เพิ่ม property สำหรับควบคุมการแสดง label

  loading: boolean[] = [false, false, false, false, false, false]
  load_group() {
    let year = this.select_year || '';
    if (year == '') { alert('กรุณาเลือกปีก่อน'); }
    //else if (root == null || root === '' || zone == null || zone === '') { alert('กรุณาระบุ โซน / รูทก่อนค้นหา'); }
    else {
      this.loading[1] = true;
      let url = this.hurl_s + `s=*&f=[dbintechgen3].[dbo].[v_area_group_code]&w=CaneYearId='${year}'`;
      axios.get(url).then(res => {
        this.loading[1] = false;
        const data = res.data;
        this.list_group = data.sort((a, b) => { return a.groupCode - b.groupCode; });
      }).catch(err => { throw err });
    }
  }

  s_group_1() {
    let group = this.select_group.map(String).map(v => `'${v}'`).join(",");;
    console.log('group:', group);
    let year = this.select_year || '';
    if (year === '') { alert('กรุณาเลือกปีก่อน'); }
    //else if (root == null || root === '' || zone == null || zone === '') { alert('กรุณาระบุ โซน / รูทก่อนค้นหา'); }
    else {
      this.loading[2] = true;
      let url = this.hurl_s + `s=*&f=[dbintechgen3].[dbo].[v_areas_kml]&w=CaneYearId='${year}'and[groupCode]in(${group})`;
      axios.get(url).then(res => {
        this.loading[2] = false;
        const data = res.data;
        let data2 = data.map(item => {
          return {
            ...item,
            point: JSON.parse(item.point),
            coordinates: JSON.parse(item.coordinates),
            //plantDate: item.plantDate.toISOString().split('T')[0] || ''
            //plantDate2: item.plantDate
          };
        });
        if (data2.length > 0) {
          const latitudes = data2.map(m => m.point.lat);
          const longitudes = data2.map(m => m.point.lng);
          // หาค่าเฉลี่ยของ lat/lng ทั้งหมด
          this.latlong.lat = latitudes.reduce((a, b) => a + b, 0) / latitudes.length;
          this.latlong.long = longitudes.reduce((a, b) => a + b, 0) / longitudes.length;
        }

        this.maps = data2;
      }).catch(err => { throw err });
    }
  }
  selectAllChecked = false;

  toggleSelectAll(): void {
    if (this.selectAllChecked) {
      let roots = this.list_group;
      this.select_group = roots.map(item => item.groupCode);
    } else {
      this.select_group = [];
    }
  }
}
